module.exports = __webpack_public_path__ + "static/media/events-hero.8d4d7430.png";